import React, {  useEffect } from "react";

import { Link, navigate } from "gatsby";
import shape1 from '../../assets/images/shape/shape1.svg'
import shape2 from '../../assets/images/shape/shape2.png'
import shape3 from '../../assets/images/shape/shape3.png'
import { isAuthorised, getUserData, isLoggedIn } from "../../services/auth";
const PageBanner = ({pageTitle, homePageUrl, homePageText, activePageText}) => {

    useEffect(() => {
       
        if(!isAuthorised("*")){
            navigate('/')
        } 


      }, []);

    return (
        <div className="console-title-area">
            <div className="container">
                <div className="page-title-content">
                   
                    <div className="brand text-center welcome-main">tell.</div>
                    <div className="subHeading text-center welcome-sub">Administration Console </div>
             
                </div>
            </div>

            <div className="shape-img1">
                <img src={shape1} alt="banner" />
            </div>
            <div className="shape-img2">
                <img src={shape2} alt="banner" />
            </div>
            <div className="shape-img3">
                <img src={shape3} alt="banner" />
            </div>
        </div>
    )
}

export default PageBanner;